// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index";
import api from "./utils/api.js";
import $url from "./utils/url.js";
import ElementUI from "element-ui";
import "./assets/theme/index.css"
// import "element-ui/lib/theme-chalk/index.css";
import scroll from 'vue-seamless-scroll'
import "@/assets/fonts/iconfont.css";
import * as echarts from "echarts";
import "./echarts/map/js/china.js";
import "swiper/js/swiper.min";
import "swiper/css/swiper.min.css";
import validate from "@/utils/validate";
import waterfall from "vue-waterfall2";
import Share from "vue-social-share";
//icon图标引用
import "./assets/icons/iconfont/iconfont.css";
import "./assets/css/common.less"

// 判断是否是手机展示
import isMobile from "../static/isMobile";
import moment from "moment";
// 富文本
import Vue2Editor from "vue2-editor";
import VueCookies from "vue-cookies";
// 计算时间
import date from "./utils/date";
// 百度地图
import BaiduMap from "vue-baidu-map";
// 视频播放
import VideoPlayer from "vue-video-player";
import "animate.css";
import { WOW } from "wowjs";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(VideoPlayer);

import Print from 'vue-print-nb'

import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);

// Vue.use(BaiduMap, {
//     ak: 'h1eqOtUG9MAWLudFeA7AQ6EpIXlmy1Vg'
//   })

Vue.use(scroll)
Vue.use(Print);
Vue.use(VueCookies);
Vue.use(Vue2Editor);
Vue.use(Share);
Vue.use(waterfall);
//定义全局变量
Vue.use(ElementUI);
Vue.prototype.api = api;
Vue.prototype.$url = $url;
Vue.prototype.$wow = new WOW({
  boxClass: "wow", // default
  animateClass: "animated", // default
  offset: 50, // default
  mobile: true, // default
  live: false,

  // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.

  callback: function(box) {
    console.log("WOW: animating <" + box.tagName.toLowerCase() + ">");
  },
});
// {
//     getToken,
//     control
// }
Vue.config.productionTip = false;
Vue.prototype.$date = date;
Vue.prototype.$echarts = echarts;
Vue.prototype.validate = validate;
Vue.prototype.$isMobile = isMobile;
Vue.prototype.moment = moment;
moment.locale("zh-cn"); //汉化moment
// Vue.$cookies.config(0, null, ".shuibengcloud.com");

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
  setTimeout(() => {
    // 此处粘贴百度统计复制过来的代码
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?f8db7bebc876d41b21ff7a78b3bcbfaf";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }, 0);
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
});



// WEBPACK FOOTER //
// ./src/main.js